"use client";

import { usePathname, useRouter } from "next/navigation";
import { imageGeneratorCategories } from "./image-generator-tools";

export function ImageGeneratorHero() {
  const router = useRouter();

  const pathname = usePathname();

  const generalUrl = "/products/ai-image-generator";

  if (!pathname) {
    router.replace(generalUrl);
    return null;
  }

  const slug = pathname.split("/").pop();
  const pageData =
    pathname === generalUrl
      ? {
          title: "Free AI Image Generator",
          subheader: "Create AI-generated images for free using text prompts",
        }
      : imageGeneratorCategories.find((c) => c.tool === slug);

  if (!pageData) {
    router.replace(generalUrl);
    return null;
  }

  return (
    <div className="flex flex-col gap-6 px-4">
      <h1 className="text-center text-3xl sm:text-6xl">{pageData.title}</h1>

      <h2 className="text-center text-base sm:text-xl">{pageData.subheader}</h2>
    </div>
  );
}
